<template>
  <div>
    <v-card class="card-shadow border-radius-xl pa-6">
      <v-row>
        <v-col cols="4">
          <div class="pb-4">
            <h6 class="mb-1 text-typo text-h6 font-weight-bold">
              Liste des places
            </h6>
            <p class="text-sm text-body">
              Ajouter, supprimer ou modifier des places
            </p>
          </div>
        </v-col>
        <v-col cols="4">
          <SearchField @search="searchUpdate"></SearchField>
        </v-col>
        <v-col cols="2">
          <v-dialog v-model="dialog" width="1000">
            <template v-slot:activator="{ on, attrs }">
              <BtnBlue
                :btnTitle="$t('appButton.add')"
                v-bind="attrs"
                v-on="on"
                @clicked="dialog = !dialog"
              ></BtnBlue>
            </template>
            <SpotListForm
              :attributes="attributes"
              :spotToUpdate="spotToUpdate"
              :key="dialog"
              @closeDialog="dialog = false"
            ></SpotListForm>
          </v-dialog>
        </v-col>
        <v-col cols="2">
          <v-menu
            transition="slide-y-transition"
            offset-y
            offset-x
            min-width="300"
            max-width="300"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="0"
                color="#fff"
                class="font-weight-bolder btn-outline-default py-4 px-2"
                small
                v-bind="attrs"
                v-on="on"
              >
                Autres actions
              </v-btn>
            </template>

            <v-list class="py-0d">
              <v-list-item
                class="pa-4 list-item-hover-active"
                @click="deleteSpots"
              >
                <v-list-item-title class="p-6"
                  >Supprimer {{ selectedSpots.length }} place{{
                    selectedSpots.length > 1 ? "s" : ""
                  }}
                  sélectionné
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                class="pa-4 list-item-hover-active"
                @click="importSpotsXls"
              >
                <v-list-item-title class="p-6"
                  >Importer excel
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <Loading v-if="loading"></Loading>
      <SpotListTable
        v-else
        :loadingMultipleDelete="loading"
        :spots="filteredSpotList"
        @spotToUpdate="updateSpot"
        @selectedSpots="updateSelectedSpots"
      ></SpotListTable>
    </v-card>
    <v-dialog v-model="dialogXls" width="400">
      <ImportXLS @closeDialog="closedialogXls"></ImportXLS>
    </v-dialog>
  </div>
</template>

<script>
import SearchField from "../common/SearchField.vue";
import BtnBlue from "../common/BtnBlue.vue";
import SpotListForm from "./SpotListForm.vue";
import SpotListTable from "./SpotListTable.vue";
import ImportXLS from "./ImportXLS.vue";
import Loading from "../common/Loading.vue";

export default {
  name: "SpotList",

  components: {
    SearchField,
    BtnBlue,
    SpotListForm,
    SpotListTable,
    ImportXLS,
    Loading,
  },

  props: {
    attributes: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      dialog: false,
      dialogXls: false,
      search: "",
      spotToUpdate: null,
      selectedSpots: [],
    };
  },

  computed: {
    spotList() {
      return this.$store.getters.spots;
    },

    filteredSpotList() {
      const dataToScan = [
        "name",
        "mandatoryAttributes",
        "forbiddenAttributes",
        "attributes",
      ];
      if (this.search === "") return this.spotList;
      return this.spotList.filter((elm) => {
        return dataToScan.some((k) => {
          const search = this.search.toLowerCase();
          if (Array.isArray(elm[k])) {
            const attr = elm[k].find((item) =>
              item.name.toLowerCase().includes(search)
            );
            return attr;
          }
          return elm[k] && String(elm[k]).toLowerCase().includes(search);
        });
      });
    },
  },

  watch: {
    dialog(nVal) {
      if (nVal == false) {
        this.spotToUpdate = null;
      }
    },
  },

  methods: {
    searchUpdate(e) {
      this.search = e;
    },

    updateSpot(item) {
      this.spotToUpdate = item;
      this.dialog = true;
    },

    updateSelectedSpots(e) {
      this.selectedSpots = e;
    },

    async deleteSpots() {
      if (this.selectedSpots.length > 0) {
        this.loading = true;
        await this.$store.dispatch("delete_spots", this.selectedSpots);
        this.selectedSpots = [];
        this.loading = false;
      }
    },

    importSpotsXls() {
      console.log("importSpotsXls method triggered");
      this.dialogXls = true;
    },

    async closedialogXls() {
      this.dialogXls = false;
      this.loading = true;
      await this.$store.dispatch("fetch_spots", this.$route.params.id);
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
